<template>
  <ToolGroupBtn
    icon="fa-link fa-light"
    :active="syncMode"
    :callback="disableAll"
    :title="$t('Sync')"
    :disable-select="isMPR"
  >
    <a-popover :title="false" trigger="click" v-if="!isMPR">
      <template slot="content">
        <a-list item-layout="horizontal" :data-source="synchronizers">
          <a-list-item
            slot="renderItem"
            slot-scope="sync"
            v-bind:class="{
              // 'ant-list-item__active': sync.enabled,
              // 'ant-list-item__disabled': !isMPR && sync.isMPR,
              'demo__weight--500': !sync.enabled,
              'demo__weight--600': sync.enabled,
            }"
          >
            <div>
              <a-checkbox :checked="sync.enabled" @change="onChange(sync)">
                <span class="demo__color--white">
                  {{ $t(sync.id) }}
                </span>
              </a-checkbox>
            </div>
          </a-list-item>
        </a-list>
      </template>
      <div class="tool-group-btn__item tool-group-btn__arrow">
        <i class="fa fa-solid fa-chevron-down"></i>
      </div>
    </a-popover>
  </ToolGroupBtn>
</template>

<script>
import { mapGetters } from "vuex";

import ToolGroupBtn from "./ToolGroupBtn";

export default {
  components: {
    ToolGroupBtn,
  },
  data() {
    return {
      test: false,
      synchronizers: [],
      cachedEnabledSyncs: [],
    };
  },
  computed: {
    ...mapGetters(["syncTool", "syncMode", "activeTools", "isMPR"]),
    syncToolActive() {
      return !!this.$_.findWhere(this.syncTool, { enable: true });
    },
  },
  beforeDestroy() {
    this.$root.$off("updateSyncs", this.setSyncs);
  },
  created() {
    this.$accessModule("sync_tool", this);

    this.$root.$on("updateSyncs", this.setSyncs);
  },
  methods: {
    disableToolsForSyncConflict() {
      this.$store.dispatch(
        "updateActiveTools",
        this.activeTools.filter((tool) => tool !== "ReferenceCursors")
      );
    },
    onChange(sync) {
      this.disableToolsForSyncConflict();

      const newState = !sync.enabled;
      this.$root.$emit("setSyncEnabled", {
        sync_id: sync.id,
        enabled: newState,
      });

      if (this.cachedEnabledSyncs.indexOf(sync.id) === -1 && newState) {
        this.cachedEnabledSyncs.push(sync.id);
      }
      if (this.cachedEnabledSyncs.indexOf(sync.id) !== -1 && !newState) {
        this.cachedEnabledSyncs = this.cachedEnabledSyncs.filter(
          (cachedSync) => {
            return cachedSync !== sync.id;
          }
        );
      }
    },
    disableAll() {
      this.disableToolsForSyncConflict();
      const isAnyEnabled = this.synchronizers.filter((sync) => {
        return sync.enabled;
      }).length;

      this.synchronizers.map((sync) => {
        this.$root.$emit("setSyncEnabled", {
          sync_id: sync.id,
          enabled: isAnyEnabled
            ? false
            : this.cachedEnabledSyncs.indexOf(sync.id) !== -1 ||
              !this.cachedEnabledSyncs.length
            ? true
            : false,
        });
      });

      if (
        this.synchronizers.length ===
        this.synchronizers.filter((sync) => sync.enabled).length
      ) {
        this.cachedEnabledSyncs = this.synchronizers.map((sync) => sync.id);
      }
    },
    setSyncs(syncs) {
      this.synchronizers = syncs;
    },
    initSyncs() {
      this.$store.dispatch("updateSyncMode", !this.syncMode);
    },
  },
};
</script>
